/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetListOfDevices200ResponseInner
 */
export interface GetListOfDevices200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetListOfDevices200ResponseInner
     */
    internalCode: string;
    /**
     * 
     * @type {number}
     * @memberof GetListOfDevices200ResponseInner
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof GetListOfDevices200ResponseInner
     */
    specialPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof GetListOfDevices200ResponseInner
     */
    stock: number;
}

/**
 * Check if a given object implements the GetListOfDevices200ResponseInner interface.
 */
export function instanceOfGetListOfDevices200ResponseInner(value: object): value is GetListOfDevices200ResponseInner {
    if (!('internalCode' in value) || value['internalCode'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('stock' in value) || value['stock'] === undefined) return false;
    return true;
}

export function GetListOfDevices200ResponseInnerFromJSON(json: any): GetListOfDevices200ResponseInner {
    return GetListOfDevices200ResponseInnerFromJSONTyped(json, false);
}

export function GetListOfDevices200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetListOfDevices200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'internalCode': json['internalCode'],
        'price': json['price'],
        'specialPrice': json['specialPrice'] == null ? undefined : json['specialPrice'],
        'stock': json['stock'],
    };
}

export function GetListOfDevices200ResponseInnerToJSON(json: any): GetListOfDevices200ResponseInner {
    return GetListOfDevices200ResponseInnerToJSONTyped(json, false);
}

export function GetListOfDevices200ResponseInnerToJSONTyped(value?: GetListOfDevices200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'internalCode': value['internalCode'],
        'price': value['price'],
        'specialPrice': value['specialPrice'],
        'stock': value['stock'],
    };
}

